<template>
  <v-dialog persistent v-model="dialog" width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">
          {{ $t("Template.batchSave.service_charge") }}
        </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>
            {{ $t("CRUD.backToList", [$t("Nav.materialTemplates")]) }}
          </span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <span>
          {{ $t("Template.batchSave.service_charge_hint") }}
        </span>
        <v-container>
          <v-form>
            <v-row>
              <!-- 分类服务费 -->
              <v-col
                cols="12"
                v-for="(category, index) in categories"
                v-bind:key="index"
              >
                <v-row>
                  <v-col cols="8">
                    <span class="d-flex">
                      {{ category.name }}{{ $t("Global.colon") }}
                    </span>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="category.service_charge_percent"
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :suffix="$t('Global.rate')"
                      @blur="
                        category.service_charge_percent =
                          category.service_charge_percent < 0
                            ? 0
                            : $numberFormatter.formatMoneyFloorWithTwoDot(
                                category.service_charge_percent
                              )
                      "
                    />
                  </v-col>
                </v-row>
                <v-divider />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" @click="SaveServiceCharge()">
          {{ $t("CRUD.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import Templates from "@/api/templates";
import i18n from "@/i18n";

export default {
  name: "DialogServiceCharge",

  props: {
    value: Boolean,
    templateId: [Number, String],
  },

  components: {},

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    categories: [],
  }),

  methods: {
    SaveServiceCharge() {
      this.$store.dispatch("fullscreenLoading");
      let postData = [];
      for (let index in this.categories) {
        postData.push({
          category_code: this.categories[index].code,
          service_charge_percent: this.categories[index].service_charge_percent
            ? this.categories[index].service_charge_percent
            : 0,
        });
      }
      if (postData.length > 0) {
        Templates.saveCategoryService({
          template_id: this.templateId,
          category_service: postData,
        })
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.dialog = false;
                this.$snackbar.info(
                  i18n.t("Template.saveSuccess", [
                    i18n.t("Template.batchSave.service_charge"),
                  ])
                );
                this.$store.dispatch("fullscreenLoadingStop");
              }
            }.bind(this)
          )
          .catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      } else {
        this.dialog = false;
        this.$store.dispatch("fullscreenLoadingStop");
      }
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          Templates.getCategoryServiceList(this.templateId).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.categories = response.data.categories;
              }
            }.bind(this)
          );
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.$emit("close");
      },
    },
  },
};
</script>